import React from "react";

const BackgroundVideo = ({ src, className = "" }) => {
  return (
    <video
      src={src}
      autoPlay
      playsInline
      loop
      muted
      className={`background-video ${className}`}
    />
  );
};

export default BackgroundVideo;
